export default "__VITE_ASSET__BEfRG_po__"